import { createContext } from "react";

export interface HighlightContextValue {
  isHighlightMode: boolean;
  toggleHighlightMode: () => void;
  highlightedIds: Set<string>;
  highlightColor: string;
  setHighlightColor: (color: string) => void;
  toggleHighlight: (id: string) => void;
  clearHighlights: () => void;
  showOnlyHighlighted: boolean;
  toggleShowOnlyHighlighted: () => void;
  importHighlights: (ids: string[], color: string, showOnly: boolean) => void;
}

export const HighlightContext = createContext<HighlightContextValue>({
  isHighlightMode: false,
  toggleHighlightMode: () => {},
  highlightedIds: new Set(),
  highlightColor: "#FFD700",
  setHighlightColor: () => {},
  toggleHighlight: () => {},
  clearHighlights: () => {},
  showOnlyHighlighted: false,
  toggleShowOnlyHighlighted: () => {},
  importHighlights: () => {},
});
